(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector-components/assets/javascripts/hooks/use-keyboard.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector-components/assets/javascripts/hooks/use-keyboard.js');
"use strict";

const {
  useMemo
} = React;
const {
  keys
} = svs.components.tipsen.drawSelectorComponents.constants;

const useKeyboard = (drawItemRefs, indexOfCentered, onSubmit) => useMemo(() => {
  const focusOnDraw = index => {
    const targetElem = drawItemRefs[index];
    const targetLink = targetElem.firstElementChild;
    targetLink.focus();
  };
  return {
    onLinkKeyDown: (event, productId, drawNumber) => {
      const {
        key
      } = event;

      if (key !== keys.tabKeys.TAB) {
        event.preventDefault();
      }
      if (Object.values(keys.navigationKeys).indexOf(key) !== -1) {
        let nextIndex = 0;
        const maxIndex = drawItemRefs.length - 1;
        if (key === keys.navigationKeys.RIGHT || key === keys.navigationKeys.DOWN) {
          nextIndex = indexOfCentered === maxIndex ? 0 : indexOfCentered + 1;
        } else {
          nextIndex = indexOfCentered === 0 && maxIndex > 0 ? maxIndex : indexOfCentered - 1;
        }
        focusOnDraw(nextIndex);
      } else if (Object.values(keys.submitKeys).indexOf(key) !== -1) {
        onSubmit(productId, drawNumber);
      }
    }
  };
}, [drawItemRefs, indexOfCentered, onSubmit]);
setGlobal('svs.components.tipsen.drawSelectorComponents.hooks.useKeyboard', useKeyboard);

 })(window);